import { http, HttpResponse } from "msw"
import type {
  ApiPurchasesSummary,
  FinancialDataPurchasesChannelsApi,
} from "../../purchases"
import { purchasesMock, purchasesSummaryMock } from "./purchases.mock"
import { purchasesChannelsMock } from "./purchasesChannels.mock"

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN

export const financialDataPurchasesHandlers = [
  http.get(`${API_DOMAIN}/api/financial-data/adherent/purchases`, () =>
    HttpResponse.json<ApiPurchasesSummary>(purchasesMock()),
  ),
  http.get(`${API_DOMAIN}/api/financial-data/pharmacies/:pharmacyId/purchases`, () =>
    HttpResponse.json<ApiPurchasesSummary>(purchasesMock()),
  ),
  http.get(
    `${API_DOMAIN}/api/financial-data/president/pharmacies/:pharmacyId/purchases`,
    () => HttpResponse.json<ApiPurchasesSummary>(purchasesMock()),
  ),
  http.get(
    `${API_DOMAIN}/api/financial-data/advisor/pharmacies/:pharmacyId/purchases`,
    () => HttpResponse.json<ApiPurchasesSummary>(purchasesMock()),
  ),

  // CHANNELS - LABORATORIES
  ...[
    "adherent",
    "pharmacies/:pharmacyId",
    "president/pharmacies/:pharmacyId",
    "advisor/pharmacies/:pharmacyId",
  ].map((path) =>
    http.get(
      `${API_DOMAIN}/api/financial-data/${path}/purchases/channels/:channelId/laboratories`,
      ({ request }) => {
        const params = new URL(request.url).searchParams
        return HttpResponse.json<FinancialDataPurchasesChannelsApi>(
          purchasesChannelsMock(
            Number(params.get("page") ?? 0),
            Number(params.get("size") ?? 15),
          ),
        )
      },
    ),
  ),

  // SUMMARY
  http.get(`${API_DOMAIN}/api/financial-data/laboratory/purchases/summary`, () =>
    HttpResponse.json(purchasesSummaryMock()),
  ),
]
